// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1ecM-","clinicsSelect":"TableHeading_clinicsSelect__2-xCH"};